export const GooglePlayLogo: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="#F7F7F7"
    {...props}
  >
    <title>Google Play Logo</title>
    <path d="M7.50178 7.26098L9.61057 5.15765L1.73167 0.693486C1.3704 0.48732 1.03787 0.453153 0.780039 0.556653L7.50178 7.26098Z" />
    <path d="M0.256851 1.44932C0.255013 1.48299 0.25 1.51349 0.25 1.54865V14.4455C0.25 14.4616 0.25117 14.4766 0.251671 14.4925L6.79278 7.96831L0.256851 1.44932Z" />
    <path d="M7.50178 8.67547L0.733418 15.4263C0.997101 15.5511 1.34851 15.5211 1.73167 15.3076L9.64817 10.8163L7.50178 8.67547Z" />
    <path d="M13.136 7.15448L10.5157 5.66931L8.21078 7.96831L10.5525 10.304L13.136 8.83964C13.9547 8.37297 13.9547 7.61464 13.136 7.15448Z" />
  </svg>
);
